import {
  Typography,
  Box,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  TextField,
  DialogActions,
  Button
} from "@material-ui/core";
import { makeStyles, Theme } from '@material-ui/core/styles';
import Close from '@material-ui/icons/Close';
import { useState } from 'react';

const useStyles = makeStyles((theme: Theme) => ({
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));


interface ResolveClosingConditionDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (comment) => void;
  title: string;
  message: string;
  closingConditionTitle: string;
  closingConditionDescription: string;
  commentRequired?: boolean;
}

export const ResolveClosingConditionDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  closingConditionTitle,
  closingConditionDescription,
  commentRequired
}: ResolveClosingConditionDialogProps) => {
  const [comment, setComment] = useState("");
  const [commentError, setCommentError] = useState("");
  const classes = useStyles();

  const confirmClickHandler = () => {
    if (commentRequired && (!comment || !comment.trim())) {
      setCommentError("Please enter a note.");
      return;
    }
    onConfirm && onConfirm(comment);
    setComment("");
    setCommentError("");
  }

  const closeHandler = () => {
    setComment("");
    setCommentError("");
    onClose && onClose();
  }

  return (
    <Dialog open={open} onClose={closeHandler} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center">
          <Typography variant="h4">{title}</Typography>
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={closeHandler}
          >
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" gridGap="1rem" marginBottom="2rem">
          <Box>
            <Typography variant="subtitle1">
              Title
            </Typography>
            <TextField
              variant="outlined"
              fullWidth
              value={closingConditionTitle}
              disabled
            />
          </Box>
          <Box>
            <Typography variant="subtitle1">
              Description
            </Typography>
            <TextField
              variant="outlined"
              fullWidth
              value={closingConditionDescription}
              multiline
              minRows={4}
              disabled
            />
          </Box>
        </Box>
        <Typography variant="subtitle1">
          Please add a note to the Closing Conversation below
        </Typography>
        <TextField
          multiline
          minRows={4}
          variant="outlined"
          fullWidth
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          error={!!commentError}
          helperText={commentError}
        />
      </DialogContent>
      <DialogActions style={{ padding: "16px 24px" }}>
        <Button onClick={closeHandler} color="primary" variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={confirmClickHandler}
          color="primary"
          variant="contained"
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};
